<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-tint card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data" v-if="node.data.isNonPromotionalChecked || node.data.isPromotionalChecked">
        <p v-if="node.data.isPromotionalChecked && node.data.promotional" key="1" class="text-center mb-0 postback_title">
          <i class="fas fa-clock"></i> {{ node.data.promotionalText }}
        </p>

        <p v-if="node.data.isNonPromotionalChecked && node.data.nonPromotional" key="2" class="text-center mb-0 postback_title">
          <i class="fas fa-sun"></i> {{ node.data.nonPromotionalText }}
        </p>
      </div>
      <div v-else class="double-click-div text-center">
        <img :src="icon_doubletap" :title="double_click_for_settings">
      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../utils/functions'

export default {
  name: 'SequenceSingleTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },
  data: () => ({
    double_click_for_settings: lang.double_click_for_settings,
    icon_doubletap: window.xitFlowBuilderData.icon_doubletap,
  }),

  methods: {
    ...templateComponentMethods,
  },
}
</script>